import React from 'react';
import { Row, Content, Message } from 'components/lib';
import {useEffect} from 'react';

export function NotFound(props) {

	useEffect(() => {
		document.title = props.t('error.404.title')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Row>
			<Content>
				<Message
					type='error'
					title={props.t('error.404.title')}
					text={props.t('error.404.text')}
					buttonText={props.t('error.404.button')}
					buttonLink='/navigate'
				/>
			</Content>
		</Row>
	);
}
